/* import components */
import Card from 'react-bootstrap/Card';
import BadgeFill from './BadgeFill';

/* import services */
import { getFirstLetterCapital } from '../utils/utils';

const IssueSummary = (props) => {

    return (
        <>
            <Card style={{ paddingBottom: "0", marginTop:"20px" }}>
                <div style={{ display: "flex"}}>
                    <img src="/assets/Customer Support.svg" width="65px" height="63px" alt="support" />
                    {props.issue.status === "closed" ? 
                    <div style={{ paddingLeft: "20px"}}>
                        <Card.Title 
                            className="grey font-semibold"
                            style={{ fontSize: "14px", marginBottom: "0" }}>
                                Thank you for reporting this
                        </Card.Title>
                        <div style={{ display: "flex" }}>
                            <BadgeFill title={getFirstLetterCapital(props.issue.status)} /> &nbsp;&nbsp;
                            <BadgeFill title={`Ticket #${props.issue.id}`} />
                        </div>
                    </div> : 
                    <div style={{ paddingLeft: "10px"}}>
                        <BadgeFill title={`Ticket #${props.issue.id}`} />
                    </div>}
                </div>
            </Card>
        </>
    )
}

export default IssueSummary;